
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_pcgz5_lpa58_103",
  "slider": "awsui_slider_pcgz5_lpa58_143",
  "slider-track": "awsui_slider-track_pcgz5_lpa58_147",
  "slider-range": "awsui_slider-range_pcgz5_lpa58_147",
  "disabled": "awsui_disabled_pcgz5_lpa58_162",
  "error": "awsui_error_pcgz5_lpa58_171",
  "active": "awsui_active_pcgz5_lpa58_174",
  "error-active": "awsui_error-active_pcgz5_lpa58_177",
  "labels": "awsui_labels_pcgz5_lpa58_184",
  "labels-noref": "awsui_labels-noref_pcgz5_lpa58_190",
  "labels-reference": "awsui_labels-reference_pcgz5_lpa58_193",
  "labels-min": "awsui_labels-min_pcgz5_lpa58_200",
  "labels-max": "awsui_labels-max_pcgz5_lpa58_206",
  "labels-aria-description": "awsui_labels-aria-description_pcgz5_lpa58_214",
  "ticks": "awsui_ticks_pcgz5_lpa58_232",
  "ticks-wrapper": "awsui_ticks-wrapper_pcgz5_lpa58_238",
  "tick": "awsui_tick_pcgz5_lpa58_232",
  "middle": "awsui_middle_pcgz5_lpa58_253",
  "filled": "awsui_filled_pcgz5_lpa58_256",
  "tooltip-thumb": "awsui_tooltip-thumb_pcgz5_lpa58_272",
  "thumb": "awsui_thumb_pcgz5_lpa58_280",
  "min": "awsui_min_pcgz5_lpa58_295",
  "max": "awsui_max_pcgz5_lpa58_298"
};
  